import * as React from 'react';
import i18nDataJson from './i18n-data.json';
import {JSONSchema7} from 'json-schema';
import { Typography } from '@mui/material';


interface I18nString {
	[k:string] : string | null;
}

interface I18nData {
	[k:string] : I18nString;
}

export type TranslateFunction = (key : string, defaultMessage? : string | undefined, context? : any | undefined) =>  string | undefined;

export function translation(lang : string, schema : JSONSchema7) {
	const translation_de = translation_intern("de", schema);
	const translation_en = translation_intern("en", schema);
	return (key : string, defaultMessage : string | undefined = undefined, context : any = undefined) : string | undefined  => {
		const result_de = translation_de(key, defaultMessage, context);
		const result_en = translation_en(key, defaultMessage, context);

		if (lang === "de") {
			return result_de
		} else {
			return result_en;
		}
	}
}
function translation_intern(lang : string, schema : JSONSchema7)  {
	return (key : string, defaultMessage : string | undefined = undefined, _context : any = undefined) : string | undefined  => {

		var i18nData : I18nData = i18nDataJson as I18nData;

		var entry = i18nData[key]
		if (entry === undefined) {
			return defaultMessage;
		}

		var translation = i18nData[key][lang];
		if (translation === undefined || translation === null) {
			var path = key.split('.');
			var currentSchema : JSONSchema7 = schema;
			for (let i = 0; i < path.length - 1; i++) {
				if (currentSchema === undefined)
					break;
				var properties = currentSchema['properties'];
				if (properties === undefined)
					break;
				else {
					var nextSchema = properties[path[i]];
					if (typeof nextSchema === 'boolean')
						break;
					else
						currentSchema = nextSchema;
				}
			}
			if (currentSchema !== undefined) {
				var field = path[path.length - 1];
				var result;
				if (field === 'label') {
					result = currentSchema['title'];
				} else if (field === 'description') {
					result = currentSchema[field];
				} else {
					result = undefined;
				}
			}

			if (result !== undefined) {
				return result;
			} else {
				return defaultMessage;
			}
		} else {
			return translation;
		}
	};
}

export function fillInJsxParagraphed(string: string | undefined, substitutions: { [k: string]: (JSX.Element | string) }) {
	if (string === undefined) {
		return <React.Fragment></React.Fragment>;
	}
	
	var paras = string.split('\n');
	
	return <React.Fragment> 
			{paras.map(p => <Typography component="p" sx={{ whiteSpace: 'pre-line', lineHeight: '2em', paddingBottom:'1em'}}>{fillIn(p, substitutions)}</Typography>)}
		</React.Fragment>;
}

export function fillInString(string: string | undefined, substitutions: { [k: string]: string }) {
	const result = fillIn(string, substitutions);
	if (typeof result === "string") {
		return result;
	} else {
		return result.join("");
	}
		
}

export function fillIn<MarkUpType>(string: string | undefined, substitutions: { [k: string]: (MarkUpType | string) }) {
	if (string === '' || string === undefined)
		return '';

	var keys = Object.keys(substitutions);

	var result = Array(0);

	// eslint-disable-next-line no-template-curly-in-string
	var segments : (MarkUpType| string)[]  = string.split(new RegExp('(\\${[^}]*})'));
	for (let k = 0; k < keys.length; k++) {
		for (let s = 0; s < segments.length; s++) {
			if (segments[s] === '${' + keys[k] + '}')
				segments[s] = substitutions[keys[k]];
		}
	}
	segments_loop: for (let s = 0; s < segments.length; s++) {
		if (segments[s] === '')
			continue;
		for (let k = 0; k < keys.length; k++) {
			if (segments[s] === '${' + keys[k] + '}') {
				result.push(substitutions[keys[k]]);
				continue segments_loop;
			}
		}
		// no substitution key matched
		result.push(segments[s]);
	}

	return result;
	
}